import { __rest } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import cls from 'classnames';
import { pickDataProps, usePrefixCls } from '../__builtins__';
import { isVoidField } from '@formily/core';
import { connect, mapProps } from '@formily/react';
import { FormLayoutShallowContext, useFormLayout } from '../form-layout';
import { List, Popover } from 'antd-mobile';
import { CheckCircleOutline, CloseCircleOutline, ExclamationCircleOutline, } from 'antd-mobile-icons';
const useFormItemLayout = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    const layout = useFormLayout();
    return Object.assign(Object.assign({}, props), { __layout__: layout.__layout__, layout: (_b = (_a = props.layout) !== null && _a !== void 0 ? _a : layout.layout) !== null && _b !== void 0 ? _b : 'horizontal', labelAlign: layout.layout === 'vertical'
            ? (_d = (_c = props.labelAlign) !== null && _c !== void 0 ? _c : layout.labelAlign) !== null && _d !== void 0 ? _d : 'left'
            : (_f = (_e = props.labelAlign) !== null && _e !== void 0 ? _e : layout.labelAlign) !== null && _f !== void 0 ? _f : 'left', labelWrap: (_g = props.labelWrap) !== null && _g !== void 0 ? _g : layout.labelWrap, labelWidth: (_h = props.labelWidth) !== null && _h !== void 0 ? _h : layout.labelWidth, wrapperWidth: (_j = props.wrapperWidth) !== null && _j !== void 0 ? _j : layout.wrapperWidth, wrapperAlign: (_k = props.wrapperAlign) !== null && _k !== void 0 ? _k : layout.wrapperAlign, wrapperWrap: (_l = props.wrapperWrap) !== null && _l !== void 0 ? _l : layout.wrapperWrap, size: (_m = props.size) !== null && _m !== void 0 ? _m : layout.size, inset: (_o = props.inset) !== null && _o !== void 0 ? _o : layout.inset, bordered: (_p = props.bordered) !== null && _p !== void 0 ? _p : layout.bordered, feedbackIcon: props.feedbackIcon, feedbackLayout: (_r = (_q = props.feedbackLayout) !== null && _q !== void 0 ? _q : layout.feedbackLayout) !== null && _r !== void 0 ? _r : 'loose', tooltipLayout: (_t = (_s = props.tooltipLayout) !== null && _s !== void 0 ? _s : layout.tooltipLayout) !== null && _t !== void 0 ? _t : 'icon', tooltipIcon: (_v = (_u = props.tooltipIcon) !== null && _u !== void 0 ? _u : layout.tooltipIcon) !== null && _v !== void 0 ? _v : (React.createElement(ExclamationCircleOutline, null)) });
};
function useOverflow() {
    const [overflow, setOverflow] = useState(false);
    const containerRef = useRef();
    const contentRef = useRef();
    useEffect(() => {
        if (containerRef.current && contentRef.current) {
            const contentWidth = contentRef.current.getBoundingClientRect().width;
            const containerWidth = containerRef.current.getBoundingClientRect().width;
            if (contentWidth && containerWidth && containerWidth < contentWidth) {
                if (!overflow)
                    setOverflow(true);
            }
            else {
                if (overflow)
                    setOverflow(false);
            }
        }
    }, []);
    return {
        overflow,
        containerRef,
        contentRef,
    };
}
const ICON_MAP = {
    error: React.createElement(CloseCircleOutline, null),
    success: React.createElement(CheckCircleOutline, null),
    warning: React.createElement(ExclamationCircleOutline, null),
};
export const BaseItem = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const [active, setActive] = useState(false);
    const formLayout = useFormItemLayout(props);
    const { containerRef, contentRef, overflow } = useOverflow();
    const { label, style, layout, feedbackStatus, extra, feedbackText, feedbackLayout, feedbackIcon, inset, bordered = true, labelWidth, wrapperWidth, labelAlign, wrapperAlign = 'left', size, labelWrap, wrapperWrap, tooltipLayout, tooltip, tooltipIcon, asterisk, } = formLayout;
    const labelStyle = Object.assign({}, formLayout.labelStyle);
    const wrapperStyle = Object.assign({}, formLayout.wrapperStyle);
    // 固定宽度
    // let enableCol = false
    if (labelWidth || wrapperWidth) {
        if (labelWidth) {
            labelStyle.width = labelWidth === 'auto' ? undefined : labelWidth;
            labelStyle.maxWidth = labelWidth === 'auto' ? undefined : labelWidth;
        }
        if (wrapperWidth) {
            wrapperStyle.width = wrapperWidth === 'auto' ? undefined : wrapperWidth;
            wrapperStyle.maxWidth = wrapperWidth === 'auto' ? undefined : wrapperWidth;
        }
        // 栅格模式
    }
    const prefixCls = usePrefixCls('formily-item');
    const formatChildren = feedbackLayout === 'popover' ? (React.createElement(Popover, { placement: "top", content: React.createElement("div", { className: cls({
                [`${prefixCls}-${feedbackStatus}-help`]: !!feedbackStatus,
                [`${prefixCls}-help`]: true,
            }) },
            ICON_MAP[feedbackStatus],
            " ",
            feedbackText), visible: !!feedbackText },
        React.createElement(React.Fragment, null, children))) : (children);
    const gridStyles = {};
    const getOverflowTooltip = () => {
        if (overflow) {
            return (React.createElement("div", null,
                React.createElement("div", null, label),
                React.createElement("div", null, tooltip)));
        }
        return tooltip;
    };
    const renderLabelText = () => {
        const labelChildren = (React.createElement(React.Fragment, null,
            asterisk && React.createElement("span", { className: `${prefixCls}-asterisk` }, '*'),
            React.createElement("div", { className: `${prefixCls}-label-content`, ref: containerRef },
                React.createElement("label", { ref: contentRef }, label))));
        if ((tooltipLayout === 'text' && tooltip) || overflow) {
            return (React.createElement(Popover, { placement: "top", content: getOverflowTooltip() }, labelChildren));
        }
        return labelChildren;
    };
    const renderTooltipIcon = () => {
        if (tooltip && tooltipLayout === 'icon' && !overflow) {
            return (React.createElement("span", { className: `${prefixCls}-label-tooltip-icon` },
                React.createElement(Popover, { placement: "right", mode: "dark", trigger: "click", content: tooltip },
                    React.createElement("span", null, tooltipIcon))));
        }
    };
    const renderLabel = () => {
        if (!label)
            return null;
        return (React.createElement("div", { className: cls({
                [`${prefixCls}-label`]: true,
                [`${prefixCls}-label-tooltip`]: (tooltip && tooltipLayout === 'text') || overflow,
            }), style: labelStyle },
            renderLabelText(),
            renderTooltipIcon()));
    };
    return (React.createElement(List.Item, Object.assign({}, pickDataProps(props), { style: Object.assign(Object.assign({}, style), gridStyles), className: cls({
            [`${prefixCls}`]: true,
            [`${prefixCls}-layout-${layout}`]: true,
            [`${prefixCls}-${feedbackStatus}`]: !!feedbackStatus,
            [`${prefixCls}-feedback-has-text`]: !!feedbackText,
            [`${prefixCls}-size-${size}`]: !!size,
            [`${prefixCls}-feedback-layout-${feedbackLayout}`]: !!feedbackLayout,
            [`${prefixCls}-active`]: active,
            [`${prefixCls}-label-align-${labelAlign}`]: true,
            [`${prefixCls}-control-align-${wrapperAlign}`]: true,
            [`${prefixCls}-label-wrap`]: !!labelWrap,
            [`${prefixCls}-control-wrap`]: !!wrapperWrap,
            // [`${prefixCls}-no-form-layout`]: !formLayout.__layout__,
            [`${prefixCls}-bordered-none`]: bordered === false || !!inset || !!feedbackIcon,
            [props.className]: !!props.className,
        }), title: layout === 'vertical' && renderLabel(), prefix: layout === 'horizontal' && renderLabel(), extra: extra && React.createElement("div", { className: cls(`${prefixCls}-extra`) }, extra), "data-grid-span": props.gridSpan }),
        React.createElement("div", { onFocus: () => {
                if (feedbackIcon) {
                    setActive(true);
                }
            }, onBlur: () => {
                if (feedbackIcon) {
                    setActive(false);
                }
            }, className: cls({
                [`${prefixCls}-control`]: true,
            }) },
            React.createElement("div", { className: cls(`${prefixCls}-control-content`) },
                React.createElement("div", { style: wrapperStyle, className: cls({
                        [`${prefixCls}-control-content-component`]: true,
                        [`${prefixCls}-control-content-component-has-feedback-icon`]: !!feedbackIcon,
                    }) },
                    React.createElement(FormLayoutShallowContext.Provider, { value: undefined }, formatChildren),
                    feedbackIcon && (React.createElement("div", { className: cls(`${prefixCls}-feedback-icon`) }, feedbackIcon)))),
            !!feedbackText &&
                feedbackLayout !== 'popover' &&
                feedbackLayout !== 'none' && (React.createElement("div", { className: cls({
                    [`${prefixCls}-${feedbackStatus}-help`]: !!feedbackStatus,
                    [`${prefixCls}-help`]: true,
                    [`${prefixCls}-help-enter`]: true,
                    [`${prefixCls}-help-enter-active`]: true,
                }) }, feedbackText)))));
};
// 适配
export const FormItem = connect(BaseItem, mapProps((props, field) => {
    if (isVoidField(field))
        return {
            label: field.title || props.label,
            asterisk: props.asterisk,
            extra: props.extra || field.description,
        };
    if (!field)
        return props;
    const takeFeedbackStatus = () => {
        if (field.validating)
            return 'pending';
        return field.decoratorProps.feedbackStatus || field.validateStatus;
    };
    const takeMessage = () => {
        const split = (messages) => {
            return messages.reduce((buf, text, index) => {
                if (!text)
                    return buf;
                return index < messages.length - 1
                    ? buf.concat([text, ', '])
                    : buf.concat([text]);
            }, []);
        };
        if (field.validating)
            return;
        if (props.feedbackText)
            return props.feedbackText;
        if (field.selfErrors.length)
            return split(field.selfErrors);
        if (field.selfWarnings.length)
            return split(field.selfWarnings);
        if (field.selfSuccesses.length)
            return split(field.selfSuccesses);
    };
    const takeAsterisk = () => {
        if (field.required && field.pattern !== 'readPretty') {
            return true;
        }
        if ('asterisk' in props) {
            return props.asterisk;
        }
        return false;
    };
    return {
        label: field.title || props.label,
        feedbackStatus: takeFeedbackStatus(),
        feedbackText: takeMessage(),
        asterisk: takeAsterisk(),
        extra: props.extra || field.description,
    };
}));
FormItem.BaseItem = BaseItem;
export default FormItem;
//# sourceMappingURL=index.js.map